// Enlaces de contacto centralizados
const WHATSAPP_PHONE = '5491130922538'
const WHATSAPP_MESSAGE = `¡Hola Guido! 👋

Estuve viendo la información del curso PADI Open Water Diver y me gustaría reservar una experiencia de buceo gratuita para conocer la escuela y vivir mi primera experiencia respirando bajo el agua.

¿Me podrías contar qué días y horarios tienen disponibles? También quisiera saber cómo puedo aprovechar la promoción vigente para los primeros inscriptos.

¡Muchas gracias!`

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`

export const INSTAGRAM_URL = 'https://instagram.com/buceoynavegacion'

export const EMAIL_URL =
  'mailto:buceoynavegacion@gmail.com?subject=Consulta%20curso%20Open%20Water%20Diver'
